/*
  This file contains definition of contract for SDK client communication
  with the host application (tenant-ios, tenant-android, etc.)
  All modifications should be reflected in tenant apps
*/

export enum HQO_SDK_ACTIONS {
  INIT = 'init',
  GET_JWT = 'getJWT',
  GET_USER = 'getUser',
  GET_BUILDING = 'getBuilding',
  GET_BUILDINGS = 'getBuildings',
  GET_HOST_INFO = 'getHostInfo',
  SHOW_NATIVE_PAYMENT = 'showNativePayment',
  HIDE_NATIVE_PAYMENTS = 'hideNativePayments',
  GET_PAYMENT_METHODS = 'getPaymentMethods',
  TOKENIZE_CARD = 'tokenizeCard',
  SET_STORAGE = 'setStorage',
  GET_STORAGE = 'getStorage',
  SET_HEADER = 'setHeader',
  SHOW_HEADER = 'showHeader',
  HIDE_HEADER = 'hideHeader',
  GET_BRAND = 'getBrand',
  GET_THEME = 'getTheme',
  SHOW_FOOTER = 'showFooter',
  HIDE_FOOTER = 'hideFooter',
  ENABLE_BACK_SWIPE = 'enableBackSwipe',
  DISABLE_BACK_SWIPE = 'disableBackSwipe',
  CLOSE_WEB_VIEW = 'closeWebView',
  LOGOUT = 'logout',
}

export enum HEADER_BUTTON_MODE {
  HISTORY = 'history',
  CLOSE = 'close',
}

export type HeaderWorkMode = HEADER_BUTTON_MODE;

export type HqOSdkData = {
  [HQO_SDK_ACTIONS.INIT]: InitMessagePayload;
  [HQO_SDK_ACTIONS.GET_JWT]: void;
  [HQO_SDK_ACTIONS.GET_USER]: void;
  [HQO_SDK_ACTIONS.GET_BUILDING]: void;
  [HQO_SDK_ACTIONS.GET_BUILDINGS]: void;
  [HQO_SDK_ACTIONS.GET_HOST_INFO]: void;
  [HQO_SDK_ACTIONS.SHOW_NATIVE_PAYMENT]: ShowNativePaymentMessagePayload;
  [HQO_SDK_ACTIONS.HIDE_NATIVE_PAYMENTS]: void;
  [HQO_SDK_ACTIONS.GET_PAYMENT_METHODS]: void;
  [HQO_SDK_ACTIONS.TOKENIZE_CARD]: TokenizeCardMessagePayload;
  [HQO_SDK_ACTIONS.GET_STORAGE]: GetStorageMessagePayload;
  [HQO_SDK_ACTIONS.SET_STORAGE]: SetStorageMessagePayload;
  [HQO_SDK_ACTIONS.SET_HEADER]: SetHeaderMessagePayload;
  [HQO_SDK_ACTIONS.SHOW_HEADER]: void;
  [HQO_SDK_ACTIONS.HIDE_HEADER]: void;
  [HQO_SDK_ACTIONS.GET_BRAND]: void;
  [HQO_SDK_ACTIONS.GET_THEME]: void;
  [HQO_SDK_ACTIONS.SHOW_FOOTER]: void;
  [HQO_SDK_ACTIONS.HIDE_FOOTER]: void;
  [HQO_SDK_ACTIONS.ENABLE_BACK_SWIPE]: void;
  [HQO_SDK_ACTIONS.DISABLE_BACK_SWIPE]: void;
  [HQO_SDK_ACTIONS.CLOSE_WEB_VIEW]: void;
  [HQO_SDK_ACTIONS.LOGOUT]: void;
};

interface InitMessagePayload {
  app_uuid: string;
}

interface ShowNativePaymentMessagePayload {
  CURRENCY?: string;
  AUTHORIZATION_TOTAL?: number;
  SUBTOTAL?: number;
  TAX?: number;
  TOTAL?: number;
  payment_gateway_id: number;
}

interface TokenizeCardMessagePayload {
  card_id: number;
  gateway_id: number;
}

export interface SetHeaderMessagePayload {
  header_title?: string;
  header_url?: string;
  header_cta_icon?: string;
  work_mode?: HeaderWorkMode;
}

interface GetStorageMessagePayload {
  key: string;
}

interface SetStorageMessagePayload {
  key: string;
  value: string;
}
